import { sendRequest } from "../request";
const BASE_URL = '/api/applicationReminders';

export function getApplicationReminders() {
    return sendRequest(`${BASE_URL}`)
}

export function createApplicationReminder(data, userID) {
    return sendRequest(`${BASE_URL}/${userID}/createApplicationReminder`, 'POST', data, 'Unable to create application reminder');
}